import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";

const MySwal = withReactContent(Swal);
const initialTime = 2000;
const endTime = 2000;
export const showAlert = (config: any) => {
    MySwal.fire(config);
};
export const handleBasicAlert = (txt: any, btnTxt: any, iconType: any) => {
    showAlert({
        icon: iconType,
        text: txt,
        confirmButtonText: btnTxt,
    });
};

export const handleWithTitle = (titleTxt: any,txt: any,  btnTxt: any) => {
    showAlert({
        title: titleTxt,
        text: txt,
        confirmButtonText: btnTxt,
    });
};

export const handleFooterAlert = (titleTxt: any, btnTxt: any, footerTxt: any) => {
    showAlert({
        title: titleTxt,
        text: btnTxt,
        footer: footerTxt,
    });
};
export const showCustomTimerAlert = (titleTxt: any, btnTxt: any, iconType: any) => {
    MySwal.fire({
        title: titleTxt,
        icon: iconType,
        confirmButtonText: btnTxt,
        timer: initialTime,
        didOpen: () => {
            const updateTimer = () => {
                const timerLeft = MySwal.getTimerLeft();
                if (timerLeft !== null && timerLeft !== undefined) {
                    MySwal.getTimerLeft(); // Refresh the timer to trigger the update

                    if (timerLeft <= endTime) {
                        clearInterval(timerInterval);
                    }
                }
            };

            const timerInterval = setInterval(updateTimer, 100);
        },
    });
};
